export const DIGITAL_LEAD_TYPE = 'digital';
export const SHOWROOM_LEAD_TYPE = 'showroom';
export const BDC_LEAD_TYPE = 'bdc';
export const NEWS_LEAD_TYPE = 'nuevos';
export const PREOWNEDS_LEAD_TYPE = 'seminuevos';
export const SERVICE_LEAD_TYPE = 'service';

export type TAreas =
    | typeof DIGITAL_LEAD_TYPE
    | typeof SHOWROOM_LEAD_TYPE
    | typeof BDC_LEAD_TYPE
    | typeof NEWS_LEAD_TYPE
    | typeof PREOWNEDS_LEAD_TYPE
    | typeof SERVICE_LEAD_TYPE;

export const WARBOX_AREAS: TAreas[] = [
    NEWS_LEAD_TYPE,
    PREOWNEDS_LEAD_TYPE,
    SHOWROOM_LEAD_TYPE,
    BDC_LEAD_TYPE,
    SERVICE_LEAD_TYPE,
];
